import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import SubmissionTimeCell from './itemComponents/SubmissionTimeCell';

export default function RenderSubmissionTime(props: GridRenderCellParams) {
	const { value } = props;
	return <SubmissionTimeCell submissionTime={value} />;
}
